export { default } from "./Offers";
